import { Icon } from '@chakra-ui/react'
import { MdWarningAmber } from 'react-icons/md'

export const InfoIcon = () => {
  return (
    <Icon as={MdWarningAmber} w={'20px'} h={'20px'} color={'#7D621D'} />
  )
}